import { userUiPreferenceStorage } from "../lib/userUiPreferenceStorage.js";
export const EVENING_RAIL_VISIBILITY_STORAGE_VERSION = 1;
export const EVENING_RAIL_VISIBILITY_STORAGE_KEY_PREFIX = `grain-saas:results:evening-rail-visibility:v${EVENING_RAIL_VISIBILITY_STORAGE_VERSION}:`;

const EVENING_RAIL_OPEN_STORAGE_VALUE = "1";

function normalizeUserId(value) {
  return typeof value === "string" ? value.trim() : "";
}

function resolveSessionStorage(storage) {
  if (storage !== undefined) {
    return storage;
  }

  const resolvedWindow = typeof window !== "undefined" ? window : null;
  if (!resolvedWindow) {
    return null;
  }

  try {
    return userUiPreferenceStorage("session");
  } catch {
    return null;
  }
}

export function buildEveningRailVisibilityStorageKey(userId) {
  const normalizedUserId = normalizeUserId(userId);
  return normalizedUserId
    ? `${EVENING_RAIL_VISIBILITY_STORAGE_KEY_PREFIX}${encodeURIComponent(normalizedUserId)}`
    : "";
}

export function resolveEveningRailVisibilityForUser(userId, visibilityState = null) {
  const normalizedUserId = normalizeUserId(userId);
  return Boolean(
    normalizedUserId
    && normalizeUserId(visibilityState?.userId) === normalizedUserId
    && visibilityState?.isOpen === true,
  );
}

export function readStoredEveningRailVisibility(userId, { storage } = {}) {
  const storageKey = buildEveningRailVisibilityStorageKey(userId);
  const resolvedStorage = resolveSessionStorage(storage);
  if (!storageKey || !resolvedStorage) {
    return false;
  }

  try {
    return resolvedStorage.getItem(storageKey) === EVENING_RAIL_OPEN_STORAGE_VALUE;
  } catch {
    return false;
  }
}

export function persistStoredEveningRailVisibility(userId, isOpen, { storage } = {}) {
  const storageKey = buildEveningRailVisibilityStorageKey(userId);
  const normalizedIsOpen = isOpen === true;
  const resolvedStorage = resolveSessionStorage(storage);
  if (!storageKey || !resolvedStorage) {
    return normalizedIsOpen;
  }

  try {
    if (normalizedIsOpen) {
      resolvedStorage.setItem(storageKey, EVENING_RAIL_OPEN_STORAGE_VALUE);
    } else {
      resolvedStorage.removeItem(storageKey);
    }
  } catch {
    // La visibilité reste active en mémoire lorsque sessionStorage est indisponible.
  }

  return normalizedIsOpen;
}

export { EVENING_RAIL_OPEN_STORAGE_VALUE };
